export default __webpack_public_path__ + "static/media/superhost-user-key-indicator-for-avatar.a4425b78.svg";